import ModalSelectHeaderMenu, {
  MenuType,
} from '@/components/sections/builder/settings/modal-select-header-menu';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import useModal from '@/hooks/useModal';
import { ExternalLinkIcon, RefreshCcwIcon, Trash2Icon } from 'lucide-react';
import { ChevronDown } from 'lucide-react';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { useGetNavigation } from '@/hooks/api/dashboard/navigation';

type HeaderMenuSettingType = {
  value?: MenuType;
  onChange?: (value?: MenuType) => void;
};

export default function HeaderMenuSetting({ value, onChange }: HeaderMenuSettingType) {
  const { storeId } = useParams<{ storeId: string }>();

  const selectMenuModal = useModal<MenuType>();

  const queryMenuDetail = useGetNavigation(value?.value, {
    enabled: !!value?.value,
  });

  const menuDetail = queryMenuDetail?.data;

  if (!value) {
    return (
      <>
        <div className='mb-4 font-bold'>Menu</div>
        <Button
          type='button'
          variant='outline'
          className='flex w-full gap-x-2 bg-white'
          onClick={() => {
            selectMenuModal.open(value);
          }}
        >
          <span>Select Menu</span>
        </Button>
        <ModalSelectHeaderMenu
          initialValues={value}
          openModal={selectMenuModal.isShow}
          setOpenModal={selectMenuModal.setIsShow}
          onSelect={(menu) => {
            onChange?.(menu);
          }}
        />
      </>
    );
  }

  return (
    <>
      <div className='mb-4 font-bold'>Menu</div>
      <div className='rounded-md bg-gray-50 py-4'>
        <div className='mb-4 border-b border-white px-4 pb-3'>
          <Link
            className='flex items-center gap-x-2'
            href={`/store/${storeId}/site/navigation/${value.value as string}`}
            target='_blank'
          >
            <div className='text-primary'>{menuDetail?.title}</div>
            <ExternalLinkIcon className='h-4 w-4 text-primary' />
          </Link>
        </div>
        <div className='px-4'>
          <DropdownMenu modal={false}>
            <DropdownMenuTrigger asChild>
              <Button type='button' variant='outline' className='flex w-full gap-x-2 bg-white'>
                <span>Change</span>
                <ChevronDown className='h-4 w-4' />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className='w-full'>
              <DropdownMenuItem
                onClick={() => {
                  selectMenuModal.open(value);
                }}
              >
                <RefreshCcwIcon className='mr-2 h-4 w-4' />
                <div>Change menu</div>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => onChange?.()}>
                <Trash2Icon className='mr-2 h-4 w-4' />
                <div>Remove menu</div>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      <ModalSelectHeaderMenu
        initialValues={value}
        openModal={selectMenuModal.isShow}
        setOpenModal={selectMenuModal.setIsShow}
        onSelect={(menu) => {
          onChange?.(menu);
        }}
      />
    </>
  );
}
